import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function CronJobs() {
    return (
        <div className={globalStyles.article}>
            <h1>Cron jobs</h1>

            <p>cron runs scheduled commands in the background. Edit your own crontab with:</p>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> crontab -e <i># edit</i><br/>
    <b>user@host:~$</b> crontab -l <i># list</i><br/>
    <b>user@host:~$</b> crontab -r <i># remove all jobs</i><br/>
            </pre>

            <h3>Syntax</h3>
            <pre className={globalStyles.code}>* * * * * command-to-run<br/>│ │ │ │ │<br/>│ │ │ │ └── day of week (0-7, 0 and 7 are Sunday)<br/>│ │ │ └──── month (1-12)<br/>│ │ └────── day of month (1-31)<br/>│ └──────── hour (0-23)<br/>└────────── minute (0-59)</pre>

            <p>Each field also accepts <b>*/n</b> (every n units), lists (<b>1,15</b>), and ranges (<b>1-5</b>).</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Examples</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>0 3 * * * /opt/scripts/backup.sh</code></td>
                        <td>Every day at 3:00 AM</td>
                    </tr>
                    <tr>
                        <td><code>*/15 * * * * /opt/scripts/healthcheck.sh</code></td>
                        <td>Every 15 minutes</td>
                    </tr>
                    <tr>
                        <td><code>0 9 * * 1-5 /opt/scripts/report.sh</code></td>
                        <td>9:00 AM, Monday through Friday</td>
                    </tr>
                    <tr>
                        <td><code>0 0 1 * * /opt/scripts/monthly-invoice.sh</code></td>
                        <td>Midnight on the 1st of every month</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Special shortcuts</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Nicknames</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>@reboot</code></td>
                        <td>Run once, at startup — handy for one-off init tasks instead of a full systemd unit</td>
                    </tr>
                    <tr>
                        <td><code>@daily</code></td>
                        <td>Same as <code>0 0 * * *</code></td>
                    </tr>
                    <tr>
                        <td><code>@hourly</code></td>
                        <td>Same as <code>0 * * * *</code></td>
                    </tr>
                    <tr>
                        <td><code>@weekly</code></td>
                        <td>Same as <code>0 0 * * 0</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>System-wide jobs</h3>
            <p>Besides per-user crontabs, cron also reads <b>/etc/crontab</b> and drop-in files under
                <b> /etc/cron.d/</b> — useful for jobs installed by a package or provisioning script, since they
                don't depend on a specific user's crontab.</p>

            <p>Cron jobs run with a minimal environment (no login shell, sparse <code>PATH</code>) — always use
                absolute paths in scripts, and redirect output to a log file to debug failures:</p>
            <pre className={globalStyles.code}>0 3 * * * /opt/scripts/backup.sh {'>>'} /var/log/backup.log 2{'>&'}1</pre>
        </div>
    )
}
